<script lang="ts">
  // Ring is a goal's progress: a circle filled by the share done, full once
  // met. The value inside is for sighted readers; the goal's text carries it
  // for screen readers.
  let { share, size = 56, icon }: { share: number; size?: number; icon?: string } = $props();
  const stroke = 6;
  let r = $derived((size - stroke) / 2);
  let circ = $derived(2 * Math.PI * r);
  let filled = $derived(Math.max(0, Math.min(1, share)));
</script>

<span class="relative inline-flex items-center justify-center shrink-0" style="width: {size}px; height: {size}px;" aria-hidden="true">
  <svg width={size} height={size} viewBox="0 0 {size} {size}">
    <circle cx={size / 2} cy={size / 2} {r} fill="none" stroke="var(--theme-surface1)" stroke-width={stroke} />
    {#if filled > 0}
    <circle cx={size / 2} cy={size / 2} {r} fill="none" stroke={filled >= 1 ? 'var(--theme-success)' : 'var(--theme-accent)'} stroke-width={stroke}
      stroke-linecap="round" stroke-dasharray="{circ * filled} {circ}" transform="rotate(-90 {size / 2} {size / 2})" />
    {/if}
  </svg>
  {#if icon}
    <i class="las {icon} absolute text-xl"></i>
  {/if}
</span>
